import { render, staticRenderFns } from "./editThirdpartyTag.vue?vue&type=template&id=ae1bc28a&scoped=true&"
import script from "./editThirdpartyTag.vue?vue&type=script&lang=js&"
export * from "./editThirdpartyTag.vue?vue&type=script&lang=js&"
import style0 from "./editThirdpartyTag.vue?vue&type=style&index=0&id=ae1bc28a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1bc28a",
  null
  
)

export default component.exports